import React from 'react';
import PropTypes from 'prop-types';
import FormSubtitle from '../../../../../../../commonComponents/forms/FormSubtitle';
import ProfileField from '../../../profile/ProfileField';
import translate from '../../../../../../../commonComponents/translate';
import CryptoCurrencyNetworkProp from '../../../../../../../commonComponents/propTypes/cryptoCurrencyNetworkProp';

function CryptoWalletList(props) {
  const {
    t,
    cryptoCurrenciesNetwork,
    userInformation,
    handleCryptoNetworkInformation,
    onCryptoWalletChange,
  } = props;
  return (
    <>
      {cryptoCurrenciesNetwork.length > 0 && (
        <>
          <FormSubtitle title={t('profile_crypto')} />
          {userInformation.cryptoWalletAddress.map(wallet => {
            const networkInfo = handleCryptoNetworkInformation(
              wallet.network,
              wallet.currency,
            );

            return (
              <React.Fragment key={`${wallet.network}_${wallet.currency}`}>
                <div className="form-group m-form__group row profile-crypto-input-container">
                  <div className="col-lg-7 offset-lg-2 col-sm-12 profile-crypto-input-label">
                    {!!networkInfo?.currencyInfo?.icon && (
                      <img
                        className="profile-crypto-input-network-icon"
                        src={networkInfo.currencyInfo.icon}
                        alt={networkInfo.networkName}
                      />
                    )}
                    <p className="profile-crypto-input-network-name">
                      {networkInfo?.networkName ?? wallet.currency}
                    </p>
                  </div>
                </div>
                <ProfileField
                  field="walletAddress"
                  value={wallet.walletAddress}
                  onChange={(_field, value) =>
                    onCryptoWalletChange(wallet.network, wallet.currency, value)
                  }
                />
              </React.Fragment>
            );
          })}
        </>
      )}
    </>
  );
}

CryptoWalletList.propTypes = {
  t: PropTypes.func.isRequired,
  userInformation: PropTypes.shape({
    cryptoWalletAddress: PropTypes.arrayOf(
      PropTypes.arrayOf(PropTypes.shape(CryptoCurrencyNetworkProp.propType)),
    ).isRequired,
  }).isRequired,
  cryptoCurrenciesNetwork: PropTypes.arrayOf(
    PropTypes.arrayOf(PropTypes.shape(CryptoCurrencyNetworkProp.propType)),
  ).isRequired,
  onCryptoWalletChange: PropTypes.func.isRequired,
  handleCryptoNetworkInformation: PropTypes.func.isRequired,
};

export default translate(CryptoWalletList);
